import React from 'react';
import '../Style/ReactionBar.css';

const REACTION_TYPES = ['FIRE', 'STRONG', 'STAR', 'HEART'];

const ReactionBar = ({
  todayCounts,
  myReactionsToday,
  handleToggle,
  isSelf,
  REACTION_EMOJIS,
  processing,
}) => {
  return (
    <div className="reaction-bar-wrapper" onClick={(e) => e.stopPropagation()}>
      <div className="reaction-buttons">
        {REACTION_TYPES.map((type) => {
          const active = myReactionsToday.includes(type);
          const count = todayCounts[type] || 0;
          const disabled = isSelf || processing;

          return (
            <button
              key={type}
              className={`reaction-btn ${active ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
              onClick={() => handleToggle(type)}
              disabled={disabled}
              title={isSelf ? "Can't react to your own card" : type}
            >
              <span className="reaction-emoji">{REACTION_EMOJIS[type]}</span>
              {count > 0 && <span className="reaction-count">{count}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ReactionBar;
